/// <reference path="constants.ts" />
module Cfnc.Security {

    export interface IAccountService {
        getUserInfo: (accessToken: string) => ng.IPromise<ng.IHttpPromiseCallbackArg<any>>;
        login: (data: ILoginBindingModel) => ng.IPromise<ng.IHttpPromiseCallbackArg<any>>;
        refreshToken(data: IRefreshTokenModel): ng.IPromise<ng.IHttpPromiseCallbackArg<any>>;
        logout(): ng.IPromise<ng.IHttpPromiseCallbackArg<any>>;
        xapLogout(): ng.IPromise<ng.IHttpPromiseCallbackArg<any>>;
        register: (data: IRegisterBindingModel) => ng.IPromise<ng.IHttpPromiseCallbackArg<any>>;
        changePassword(data: any): ng.IPromise<ng.IHttpPromiseCallbackArg<any>>;
        getToken(clientId: string): ng.IPromise<ng.IHttpPromiseCallbackArg<any>>;
    }

    export class AccountService implements IAccountService {
        static serviceId: string = "accountService";
        private formdataHeader: any;

        constructor(private $http: ng.IHttpService, private urls: IAccountUrls) {
            this.formdataHeader = { "Content-Type": "application/x-www-form-urlencoded" };
        }

        private parameterize = (data: any): any => {
            var param = (obj: any): any => {
                var query = "";
                var subValue, fullSubName, innerObj, i;
                angular.forEach(obj, function (value, name: any) {
                    if (value instanceof Array) {
                        for (i = 0; i < value.length; ++i) {
                            subValue = value[i];
                            fullSubName = name + "[" + i + "]";
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + "&";
                        }
                    }
                    else if (value instanceof Object) {
                        angular.forEach(value, function (subValue, subName) {
                            fullSubName = name + "[" + subName + "]";
                            innerObj = {};
                            innerObj[fullSubName] = subValue;
                            query += param(innerObj) + "&";
                        });
                    }
                    else if (value !== undefined && value !== null) {
                        query += encodeURIComponent(name) + "=" + encodeURIComponent(value) + "&";
                    }
                });
                return query.length ? query.substr(0, query.length - 1) : query;
            };
            return angular.isObject(data) && String(data) !== "[object File]" ? param(data) : data;
        };

        getUserInfo = (accessToken: string): ng.IPromise<ng.IHttpPromiseCallbackArg<IUserInfoView>> => {
            return this.$http({ url: this.urls.host + this.urls.userInfo, method: "GET", headers: { "Authorization": "Bearer " + accessToken } });
        };

        login = (data: ILoginBindingModel): ng.IPromise<any> => {
            return this.$http({ method: 'POST', url: this.urls.host + this.urls.login, data: this.parameterize(data), headers: this.formdataHeader });
        }

        refreshToken(data: IRefreshTokenModel): ng.IPromise<ng.IHttpPromiseCallbackArg<any>> {
            return this.$http({ method: "POST", url: this.urls.host + this.urls.login, data: this.parameterize(data), headers: this.formdataHeader });
        }

        logout(): ng.IPromise<ng.IHttpPromiseCallbackArg<any>> {
            return this.$http({ method: "POST", url: this.urls.host + this.urls.logout });
        }

        xapLogout(): ng.IPromise<ng.IHttpPromiseCallbackArg<any>> {
            return this.$http({ method: "GET", url: this.urls.xapHost + this.urls.xapLogout });
        }

        register = (data: IRegisterBindingModel): ng.IPromise<any> => {
            return this.$http({ method: 'POST', url: this.urls.host + this.urls.join, data: data });
        }

        changePassword(data: any): ng.IPromise<ng.IHttpPromiseCallbackArg<any>> {
            return this.$http({ method: "POST", url: this.urls.changePassword, data: data });
        }

        getToken = (clientId: string): ng.IPromise<ng.IHttpPromiseCallbackArg<ILoginBindingModel>> => {
            return this.$http(<any>{ url: this.urls.host + this.urls.exchangeToken + "?clientId=" + clientId, method: "GET", ignoreAuthModule: true, headers: { "Authorization": "Bearer clear" } });
        };
    }
}